import { auth } from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged as firebaseOnAuthStateChanged,
  sendPasswordResetEmail,
  User,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";

export const signUp = async (email: string, password: string) => {
  await setPersistence(auth, browserLocalPersistence);
  return createUserWithEmailAndPassword(auth, email, password);
};

export const signIn = async (email: string, password: string) => {
  await setPersistence(auth, browserLocalPersistence);
  return signInWithEmailAndPassword(auth, email, password);
};

export const signOut = async () => {
  return firebaseSignOut(auth);
};

export const onAuthStateChanged = (callback: (user: User | null) => void) => {
  return firebaseOnAuthStateChanged(auth, callback);
};

export const resetPassword = async (email: string) => {
  // Get the current origin for redirect URL
  const actionCodeSettings = {
    url: `${window.location.origin}/signin`,
    handleCodeInApp: false, // Set to true if you want to handle the code in your app
  };

  try {
    await sendPasswordResetEmail(auth, email, actionCodeSettings);
    return;
  } catch (error: any) {
    throw error;
  }
};
